import { forgotPasswordApiRequest } from '@utils/request';
import { forgotPasswordEmailSubmission } from 'types/forgot-password';
import { ForgotPasswordMetaData } from 'types/forgot-password';
import { oauthRequest } from '@utils/request';

export async function getForgotPasswordMetaData(): Promise<ForgotPasswordMetaData> {
	const response = await forgotPasswordApiRequest.get(`/forgot-password/forgot-password-metadata`);
	return response.data;
}

export const resetPasswordEmailRequest = async (submissionForm: forgotPasswordEmailSubmission): Promise<void> => {
	await oauthRequest.post(`/identity/forgot-password/send-email`, {
		captcha3Answer: submissionForm.captcha3Answer,
		mixpanelId: submissionForm.mixpanelId,
		username: submissionForm.username
	});
};
